module.exports = __webpack_public_path__ + "img/saas.6dee0c2a.png";